/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Manual_Qc_Delete_ConfirmInputs */



/**
* | output |
* | --- |
* | "Are you sure you want to delete \"{name}\"?" |
*
* @param {Manual_Qc_Delete_ConfirmInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_delete_confirm = /** @type {((inputs: Manual_Qc_Delete_ConfirmInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Delete_ConfirmInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Voulez-vous vraiment supprimer "${i?.name}" ?`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Möchten Sie "${i?.name}" wirklich löschen?`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Sei sicuro di voler eliminare "${i?.name}"?`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Вы уверены, что хотите удалить "${i?.name}"?`)
	if (locale === "es") return /** @type {LocalizedString} */ (`¿Estás seguro de que deseas eliminar "${i?.name}"?`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`您确定要删除“${i?.name}”吗？`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`「${i?.name}」を削除してもよろしいですか?`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`क्या आप वाकई "${i?.name}" को हटाना चाहते हैं?`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Tem certeza de que deseja excluir "${i?.name}"?`)
	return /** @type {LocalizedString} */ (`Are you sure you want to delete "${i?.name}"?`)
});